<nz-modal
  [nzVisible]="true"
  [nzFooter]="null"
  [nzWidth]="636"
  [nzTitle]="deleteTitle()"
  (nzOnCancel)="onClose(false)"
  [nzCloseIcon]="closeIcon"
  [nzContent]="modalContent"
  [nzMaskClosable]="false"
>
  <ng-template #closeIcon>
    @if (!isEquipmentSensorDeleted()) {
      <img alt="closeTab" src="assets/icons/exit_new.svg" />
    }
  </ng-template>

  <ng-template #modalContent>
    @if (!isEquipmentSensorDeleted()) {
      <div class="card-layer" [class.mobile]="isMobile()">
        <!-- Title set -->
        @if (objType() === "") {
          <h1>
            {{ i18n.langString("delete_hint_equipment") }}
            {{ objName() }}
            {{ i18n.langString("want_to_delete_2") }}
          </h1>
        }
        @if (objType() === "plant") {
          <h1>
            {{ i18n.langString("delete_hint_plant") }}
            {{ i18n.langString("want_to_delete_2") }}
          </h1>
        }
        @if (objType() === "building") {
          <h1>
            {{ i18n.langString("delete_hint_building") }}
            {{ i18n.langString("want_to_delete_2") }}
          </h1>
        }
        @if (objType() === "area") {
          <h1>
            {{ i18n.langString("delete_hint_area") }}
            {{ i18n.langString("want_to_delete_2") }}
          </h1>
        }
        @if (objType() === "sensor") {
          <h1>
            {{ i18n.langString("delete_hint_sensor") }}
            {{ objName() }}
            {{ i18n.langString("want_to_delete_2") }}
          </h1>
        }
        @if (objType() === "floor") {
          <h1>
            {{ i18n.langString("delete_hint_floor") }}
            {{ i18n.langString("want_to_delete_2") }}
          </h1>
        }
        @if (objType() === "section") {
          <h1>
            {{ i18n.langString("delete_hint_section") }}
            {{ i18n.langString("want_to_delete_2") }}
          </h1>
        }
        @if (objType() === "associatedeq") {
          <h1>
            {{ i18n.langString("delete_hint_associatedeq") }}
            {{ i18n.langString("want_to_delete_2") }}
          </h1>
        }
        @if (objType() === "zone") {
          <h1>
            {{ i18n.langString("delete_hint_zone") }}
            {{ i18n.langString("want_to_delete_2") }}
          </h1>
        }
        @if (objType() === "scrossing") {
          <h1>
            {{ i18n.langString("delete_hint_scrossing") }}
            {{ i18n.langString("want_to_delete_2") }}
          </h1>
        }

        <!-- Equipment/Sensor subtitle area -->
        @if (isEquipmentOrSensor()) {
          <div class="delete-equip-subtitle-content">
            @if (objType() === "") {
              <p class="regular black-coral-text subtitle-content">
                {{ i18n.langString("delete_equipment_subtitle_hint") }}
              </p>
            }
            @if (objType() === "sensor") {
              <p class="regular black-coral-text subtitle-content">
                {{ i18n.langString("delete_sensor_subtitle_hint") }}
              </p>
            }

            <div class="delete-info-hint">
              <span>
                <i
                  nz-icon
                  [nzType]="'icons:exclamation_vector'"
                  class="svg-icon"
                ></i>
              </span>
              <span class="info-hint">
                {{ i18n.langString("delete_undone") }}
              </span>
            </div>
          </div>
        }

        <!-- Action buttons -->
        <div class="buttonwrapper equipmentSensor">
          <app-nav-button
            class="del_btn_wid"
            [darksecondary]="true"
            (clickEvent)="onClose(false)"
          >
            {{
              isEquipmentOrSensor()
                ? i18n.langString("no_keep")
                : i18n.langString("no_keep_it")
            }}
          </app-nav-button>

          <app-nav-button
            class="del_btn_wid"
            [primary]="true"
            (clickEvent)="closeEvent.emit(true)"
          >
            {{
              isEquipmentOrSensor()
                ? deleteButtonTitle()
                : i18n.langString("yes_delete")
            }}
          </app-nav-button>
        </div>
      </div>
    }

    <!-- Confirmation block after deletion -->
    @if (isEquipmentSensorDeleted()) {
      <div class="card-layer-equipsensor" [class.mobile]="isMobile()">
        @if (equipmentDeletePopup()) {
          <h1>{{ i18n.langString("delete_equipment_confirmation") }}</h1>
        }
        @if (sensorDeletePopup()) {
          <h1>{{ i18n.langString("delete_sensor_confirmation") }}</h1>
        }

        <div class="buttonwrapper confirm_delete">
          @if (equipmentDeletePopup()) {
            <app-nav-button
              class="del_btn_wid"
              [primary]="true"
              (clickEvent)="confirmDelete.emit('equipment')"
            >
              {{ i18n.langString("go_back_to_plant_overwiew") }}
            </app-nav-button>
          }
          @if (sensorDeletePopup()) {
            <app-nav-button
              class="del_btn_wid"
              [primary]="true"
              (clickEvent)="confirmDelete.emit('sensor')"
            >
              {{ i18n.langString("go_back_to_equipment_overwiew") }}
            </app-nav-button>
          }
        </div>
      </div>
    }
  </ng-template>
</nz-modal>
